var _defs, _path, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,10.43H4.65c-1.54,0-2.78,1.08-2.78,2.41v5.93c0,.67.62,1.21,1.4,1.21h2.15c.77,0,1.4-.54,1.4-1.21v-.47c0-.49.46-.89,1.03-.89h8.31c.57,0,1.03.4,1.03.89v.47c0,.67.62,1.21,1.4,1.21h2.15c.77,0,1.4-.54,1.4-1.21v-5.93c0-1.33-1.25-2.41-2.78-2.41Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.68,
    y1: 13.5,
    x2: 8.67,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.33,
    y1: 13.5,
    x2: 19.32,
    y2: 13.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.18,10.43l2.26-5.42c.13-.57.78-.99,1.52-.99h5.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.82,10.43l-2.26-5.42c-.13-.57-.78-.99-1.52-.99h-5.03"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.95,
    y1: 10.43,
    x2: 1.64,
    y2: 9.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.05,
    y1: 10.43,
    x2: 22.36,
    y2: 9.13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon_car.fa386c0d5efc602824b3fdbabb869c11.svg";
export { ForwardRef as ReactComponent };